<template>
  <div class="box box-success">
    <div class="box-body">
      <div class="col-md-12">
        <div class="row">
          <div class="form-group">
            <button
              type="button"
              class="btn btn-labeled btn-primary pull-right"
              @click="onAddNew"
              style="margin-right: 5px;"
            >
              <span class="btn-label"> <i class="fa fa-plus"></i> </span>
              {{ $t("common.addnew") }}
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-12" style="margin-top: 15px">
        <b-table striped hover :items="productItems" :fields="productFields">
          <template #head()="scope">
            <div class="">{{ $t(scope.label) }}</div>
          </template>
          <template #cell(productUnit)="row">
            {{ row.item.productUnitName }}
          </template>
          <template #cell(productGroup)="row">
            {{ row.item.productGroupName }}
          </template>
          <template #cell(actions)="row">
            <div class="btn-group">
              <button
                type="button"
                class="btn btn-danger dropdown-toggle"
                data-toggle="dropdown"
                aria-expanded="true"
              >
                <i class="fa fa-fw fa-ellipsis-h"></i>
              </button>
              <ul class="dropdown-menu" style="min-width: 50px">
                <li>
                  <button
                    v-if="
                      GET_ACCOUNT_DATA.id == 1 || has_perm('update_apartment')
                    "
                    class="btn btn-primary btn-sm"
                    style="margin-left: 6px;"
                    @click="onOpenEditInput(row.item)"
                  >
                    <i class="glyphicon glyphicon-edit"></i>
                  </button>
                </li>
                <li style="margin-top: 5px">
                  <button
                    v-if="
                      GET_ACCOUNT_DATA.id == 1 || has_perm('delete_apartment')
                    "
                    class="btn btn-danger btn-sm"
                    style="margin-left: 6px;"
                    @click="onOpenDelete(row.item)"
                  >
                    <i class="glyphicon glyphicon-trash"></i>
                  </button>
                </li>
              </ul>
            </div>
          </template>
        </b-table>
        <div class="box-footer clearfix" style="display:contents;">
          <custom-paginator
            :totalItem="paginateData.totalItem"
            :currentPage="paginateData.currentPage"
            :pageSize="paginateData.pageSize"
            :totalPage="paginateData.totalPage"
            @onpaginate="onCustomPagination"
          />
        </div>
      </div>
    </div>
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <!--  -->
    <product-detail
      ref="productDetail"
      @callbackGetProduct="callbackGetProduct"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import LTEModal from "@/components/LTEModal.vue";
import ProductDetail from "./ProductDetail.vue";
import CustomPaginator from "@/components/CustomPaginator.vue";

import Enum from "../../../enum/enum";
import utils from "@/lib/utils";
export default {
  components: {
    "lte-modal": LTEModal,
    ProductDetail,
    CustomPaginator
  },
  data: () => ({
    productFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "productCode",
        label: "product.productList.productCode"
      },
      {
        key: "productName",
        label: "product.productList.productName"
      },
      {
        key: "productGroupName",
        label: "product.productGroup"
      },
      {
        key: "productUnitName",
        label: "product.productUnit"
      },
      {
        key: "productPrice",
        label: "product.productList.productPrice"
      },
      {
        key: "productDescription",
        label: "product.productList.productDescription"
      },
      { key: "actions", label: "common.action" }
    ],
    productItems: [],
    isModalVisible: false,
    originalRecordData: null,
    objModal: [
      {
        title: "common.delete_modal.title",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    productGroupList: [],
    productUnitList: []
  }),
  watch: {
    GET_PRODUCT_LIST_DATA: function() {
      let paginate = this.GET_PRODUCT_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      let data = this.GET_PRODUCT_LIST_DATA.results;
      this.productItems = [];
      data.forEach((value, index) => {
        let nonumber =
          index +
          1 +
          (this.paginateData.currentPage - 1) * this.paginateData.pageSize;
        let item = {
          id: value.id,
          nonumber: nonumber,
          productCode: value.code,
          productName: value.name,
          productGroupName: value.product_group.name,
          productGroup: value.product_group.id,
          productUnitName: value.product_unit.name,
          productUnit: value.product_unit.id,
          productPrice: value.price,
          productDescription: value.description
        };
        this.productItems.push(item);
      });
    },
    GET_PRODUCT_GROUP_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_PRODUCT_GROUP_LIST_NO_PAGE_DATA;
      this.productGroupList = [];
      data.forEach(value => {
        let item = {
          id: value.id,
          productGroupName: value.name,
          description: value.description
        };
        this.productGroupList.push(item);
      });
    },
    GET_PRODUCT_UNIT_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_PRODUCT_UNIT_LIST_NO_PAGE_DATA;
      this.productUnitList = [];
      data.forEach(value => {
        let item = {
          id: value.id,
          productUnit: value.name,
          description: value.description
        };
        this.productUnitList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_PRODUCT_LIST_DATA",
      "GET_PRODUCT_GROUP_LIST_NO_PAGE_DATA",
      "GET_PRODUCT_UNIT_LIST_NO_PAGE_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onAddNew: function() {
      this.$refs.productDetail.onShowAddNew(
        Enum.ApartmentImgType.APARTMENT_MAP_IMG
      );
    },
    onOpenEditInput: function(data) {
      this.$refs.productDetail.onShowDetail(data);
    },
    onViewImgNewTab: function(data) {
      window.open(data);
    },
    onOpenDelete: function(data) {
      this.originalRecordData = data;
      this.isModalVisible = true;
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_PRODUCT(this.originalRecordData)
        .then(
          function() {
            this.callbackGetProduct();
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    closeModal() {
      this.isModalVisible = false;
    },
    getProductList: function(page) {
      let filter = {
        params: {
          page: page
        }
      };
      this.GET_PRODUCT_LIST(filter);
    },
    onCallbackData: async function() {
      await this.getProductGroup();
      await this.getProductUnit();
      await this.getProductList(1);
    },
    callbackGetProduct: function() {
      this.getProductList(this.paginateData.currentPage);
    },
    onCustomPagination: function(data) {
      this.paginateData.currentPage = data;
      this.getProductList(data);
    },
    getProductGroup: function() {
      this.GET_PRODUCT_GROUP_LIST();
    },
    getProductUnit: function() {
      this.GET_PRODUCT_UNIT_LIST();
    },
    getProductGroupName: function(value) {
      let result = "";
      let index = this.productGroupList.findIndex(x => x.id === value);
      if(index !== -1) {
        result = this.productGroupList[index].productGroupName
      }
      return result;
    },
    getProductUnitName: function(value) {
      let result = "";
      let index = this.productUnitList.findIndex(x => x.id === value);
      if(index !== -1) {
        result = this.productUnitList[index].productUnit
      }
      return result;
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_PRODUCT_LIST",
      "DELETE_PRODUCT",
      "GET_PRODUCT_GROUP_LIST",
      "GET_PRODUCT_UNIT_LIST"
    ])
  },
  async mounted() {
    await this.getProductList(1);
    await this.getProductGroup();
    await this.getProductUnit();
  }
};
</script>
<style scoped>
.asset-img-class {
  width: 100%;
  max-width: 75px;
  max-height: 100px;
  object-fit: contain;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Product/ProductList.vue